import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({ ...args }) {
    super(args)
    this.attrs.error = ''
    this.children = [
      {
        ...this.getComponentWithVModel('related-categories-input'),
        props: {
          errors: this.getErrorsForPath(this.modelPath)
        }
      }
    ]
  }
}
